import TypedNativeModules from "../internal/TypedNativeModules";
import type { TareBridge } from "../types/TareBridge";

/**
 * This method is used to get the TareBridge native module.
 * Rather than accessing TypedNativeModules directly.
 */
export function getTareBridge(): TareBridge | null {
  return TypedNativeModules.RNTareBridge;
}
